import { Dispatch, GetState } from "common/types/redux";

import {
  doesCourseHaveExamQuestions,
  getCourseName
} from "seneca-common/features/course/state";
import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";
import uuid from "seneca-common/utils/functions/uuid";
import {
  analyticsCategories,
  logGTMTrackingEvent,
  withLogAndSwallowError
} from "seneca-common/utils/senecaAnalytics";

import { individualAssignmentsStateConfig } from "../state/consts";
import { getAssignmentNumberOfAssignees } from "../state/selectors";
import generateAssignmentAnalyticsPayload from "./payload";

const {
  // @ts-ignore
  createActionTypes: { "CREATE_TEACHER-ASSIGNMENTS_SUCCESS": createAction }
} = makeCrudStateActionFactories(individualAssignmentsStateConfig);

export const analyticsLogCreateAssignment =
  withLogAndSwallowError(logCreateAssignment);

export const analyticsLogCreateAssignmentsAcrossClasses =
  withLogAndSwallowError(logCreateAssignmentsAcrossClasses);

function logCreateAssignment(payload: any) {
  return (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    createAssignmentGTMTrackingEvent(state, payload);
  };
}

function logCreateAssignmentsAcrossClasses(assignments: any[]) {
  return (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const multiAssignmentCorrelationId = uuid();

    assignments.forEach(payload => {
      createAssignmentGTMTrackingEvent(state, {
        multiAssignmentCorrelationId,
        ...payload
      });
    });
  };
}

function createAssignmentGTMTrackingEvent(state: any, payload: any) {
  const { id, classId, spec } = payload;
  const { courseId, questionIds } = spec;
  const courseName = courseId && getCourseName(state, courseId);

  const courseHasExamQuestions = doesCourseHaveExamQuestions(state, courseId);
  const numExamQuestions = !!courseHasExamQuestions ? questionIds.length : null;

  logGTMTrackingEvent(
    {
      category: analyticsCategories.ASSIGNMENT,
      event: createAction,
      payload: {
        ...payload,
        ...generateAssignmentAnalyticsPayload(state, classId),
        numberOfAssignees: getAssignmentNumberOfAssignees(state, id),
        courseId,
        courseName,
        assignmentId: id,
        numExamQuestions
      }
    },
    state
  );
}
